const OrderInProgress = require('@/lib/Orders/OrderInProgress');
/**
 * @constructor
 *
 * @param {CartStashHelper} cartStashHelperService
 * @param {UserService} userService
 */
const OrderInProgressStasher = function (
    cartStashHelperService,
    userService,
) {
    this.cartStashHelper = cartStashHelperService;
    this.userService = userService;
};

OrderInProgressStasher.prototype = {
    /**
     * Update the copy of the cart stored in the current user's session.
     *
     * @param {CartService} cartService
     *
     * @returns {Promise}
     */
    async setCart(cartService) {
        this.getOrderInProgress().stashedCart = this.cartStashHelper.cartToStash(cartService);
        return this.saveCache();
    },

    /**
     * @param {string} state
     *
     * @returns {Promise}
     */
    async setState(state) {
        this.getOrderInProgress().state = state;
        return this.saveCache();
    },

    /**
     * @returns {OrderInProgress}
     */
    getOrderInProgress() {
        if (!this.userService.currentUserSession) {
            throw new Error('No current user session- cannot get order in progress.');
        }

        if (!this.userService.currentUserSession?.orderInProgress) {
            this.userService.currentUserSession.orderInProgress = new OrderInProgress();
        }

        return this.userService.currentUserSession.orderInProgress;
    },

    async saveCache() {
        await this.userService.persistCurrentUserSession();
    },
};

module.exports = OrderInProgressStasher;
